import { cn } from "./cn";

export function HorizontalDivider() {
  return <div className={cn("w-full my-2 h-[1px] bg-divider")} />;
}
